import React from 'react'

import { Card } from 'polythene-react'

export default function Template({ data }) {
  const { markdownRemark } = data // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark

  const content = (
    <div>
      <br />
      <div
        className="flow-text"
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    </div>
  )

  return (
    <div className="full-app-card-wrapper prefix-10 grid-80">
      <Card
        className="full-app-card flow-text"
        content={[
          {
            primary: {
              title: frontmatter.title,
              subtitle: frontmatter.summary,
            },
          },
          {
            text: {
              content: content,
            },
          },
        ]}
      />
    </div>
  )
}

export const pageQuery = graphql`
  query MDPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        summary
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/mdTemplate.js